import {getEmergencyOverrides} from '@account/api/admin-reports';
import {useQuery} from '@tanstack/react-query';

export const useEmergencyOverrides = (
  {start, end, limit = 50, offset = 0},
  options = {}
) =>
  useQuery(
    ['admin-reports', 'emergency-overrides', start, end, limit, offset],
    () => getEmergencyOverrides({start, end, limit, offset}),
    {keepPreviousData: true, ...options}
  );
